/* eslint-disable @typescript-eslint/no-duplicate-enum-values */ /* eslint-disable @typescript-eslint/naming-convention */ /**
 * uses `_` as delimiter in plan name (Premium_Yearly for eg)
 * since plan or duration can have longer names delimited by `-`
 * (Enterprise-Tiered_Yearly, Premium_Half-Yearly for eg)
 */ export var BillingVersion = /*#__PURE__*/ function(BillingVersion) {
    BillingVersion["v1"] = "v1";
    BillingVersion["v2"] = "v2";
    return BillingVersion;
}({});
export var SupportedPlans = /*#__PURE__*/ function(SupportedPlans) {
    SupportedPlans["Professional"] = "Professional";
    SupportedPlans["Premium"] = "Premium";
    SupportedPlans["Premium-V2"] = "Premium-V2";
    SupportedPlans["Enterprise"] = "Enterprise";
    SupportedPlans["Enterprise-V2"] = "Enterprise-V2";
    SupportedPlans["Essentials"] = "Essentials";
    SupportedPlans["Standard"] = "Standard";
    return SupportedPlans;
}({});
export var SupportedPlansType = /*#__PURE__*/ function(SupportedPlansType) {
    SupportedPlansType["Professional"] = "Professional";
    SupportedPlansType["Premium"] = "Premium";
    SupportedPlansType["Premium-V2"] = "Premium_V2";
    SupportedPlansType["Enterprise"] = "Enterprise";
    SupportedPlansType["Enterprise-V2"] = "Enterprise_V2";
    SupportedPlansType["Essentials"] = "Essentials";
    SupportedPlansType["Standard"] = "Standard";
    return SupportedPlansType;
}({});
export var RestrictedPlans = /*#__PURE__*/ function(RestrictedPlans) {
    RestrictedPlans["Enterprise-Tiered"] = "Enterprise-Tiered";
    RestrictedPlans["Enterprise-Tiered-V2"] = "Enterprise-Tiered-V2";
    return RestrictedPlans;
}({});
var PlanHierarchy_v1 = /*#__PURE__*/ function(PlanHierarchy_v1) {
    PlanHierarchy_v1[PlanHierarchy_v1["Professional"] = 1] = "Professional";
    PlanHierarchy_v1[PlanHierarchy_v1["Premium"] = 2] = "Premium";
    PlanHierarchy_v1[PlanHierarchy_v1["Enterprise"] = 3] = "Enterprise";
    PlanHierarchy_v1[PlanHierarchy_v1["Enterprise-Tiered"] = 3] = "Enterprise-Tiered";
    return PlanHierarchy_v1;
}(PlanHierarchy_v1 || {});
var PlanHierarchy_v2 = /*#__PURE__*/ function(PlanHierarchy_v2) {
    PlanHierarchy_v2[PlanHierarchy_v2["Essentials"] = 1] = "Essentials";
    PlanHierarchy_v2[PlanHierarchy_v2["Standard"] = 2] = "Standard";
    PlanHierarchy_v2[PlanHierarchy_v2["Premium-V2"] = 3] = "Premium-V2";
    PlanHierarchy_v2[PlanHierarchy_v2["Enterprise-V2"] = 4] = "Enterprise-V2";
    PlanHierarchy_v2[PlanHierarchy_v2["Enterprise-Tiered-V2"] = 4] = "Enterprise-Tiered-V2";
    return PlanHierarchy_v2;
}(PlanHierarchy_v2 || {});
export const PlanHierarchy = {
    ["v1"]: PlanHierarchy_v1,
    ["v2"]: PlanHierarchy_v2
};
/**
 * TODO: to be fetched from CB via our BE.
 */ export var YearlyPrice = /*#__PURE__*/ function(YearlyPrice) {
    YearlyPrice[YearlyPrice["Professional"] = 19] = "Professional";
    YearlyPrice[YearlyPrice["Premium"] = 49] = "Premium";
    YearlyPrice[YearlyPrice["Enterprise"] = 99] = "Enterprise";
    YearlyPrice[YearlyPrice["Essentials"] = 19] = "Essentials";
    YearlyPrice[YearlyPrice["Standard"] = 49] = "Standard";
    YearlyPrice[YearlyPrice["Premium-V2"] = 69] = "Premium-V2";
    YearlyPrice[YearlyPrice["Enterprise-V2"] = 99] = "Enterprise-V2";
    return YearlyPrice;
}({});
export var MonthlyPrice = /*#__PURE__*/ function(MonthlyPrice) {
    MonthlyPrice[MonthlyPrice["Professional"] = 29] = "Professional";
    MonthlyPrice[MonthlyPrice["Premium"] = 59] = "Premium";
    MonthlyPrice[MonthlyPrice["Essentials"] = 29] = "Essentials";
    MonthlyPrice[MonthlyPrice["Standard"] = 59] = "Standard";
    MonthlyPrice[MonthlyPrice["Premium-V2"] = 79] = "Premium-V2";
    return MonthlyPrice;
}({});
export var BillingCycle = /*#__PURE__*/ function(BillingCycle) {
    BillingCycle["Monthly"] = "monthly";
    BillingCycle["Yearly"] = "yearly";
    BillingCycle["Quarterly"] = "quarterly";
    BillingCycle["Half-Yearly"] = "half-yearly";
    return BillingCycle;
}({});
export const AvailablePlans = {
    v1: [
        "Professional",
        "Premium",
        "Enterprise"
    ],
    v2: [
        "Essentials",
        "Standard",
        "Premium-V2",
        "Enterprise-V2"
    ]
};
// Numeric enum to get planId (enums are numberic by default)
export var PlanIds = /*#__PURE__*/ function(PlanIds) {
    PlanIds[PlanIds["Premium_Yearly"] = 1] = "Premium_Yearly";
    PlanIds[PlanIds["Premium_Quarterly"] = 2] = "Premium_Quarterly";
    PlanIds[PlanIds["Premium_Monthly"] = 3] = "Premium_Monthly";
    PlanIds[PlanIds["Professional_Yearly"] = 4] = "Professional_Yearly";
    PlanIds[PlanIds["Professional_Quarterly"] = 5] = "Professional_Quarterly";
    PlanIds[PlanIds["Professional_Monthly"] = 6] = "Professional_Monthly";
    PlanIds[PlanIds["Enterprise_Yearly"] = 7] = "Enterprise_Yearly";
    PlanIds[PlanIds["Premium_Half-Yearly"] = 8] = "Premium_Half-Yearly";
    PlanIds[PlanIds["Professional_Half-Yearly"] = 9] = "Professional_Half-Yearly";
    PlanIds[PlanIds["Enterprise-Tiered_Yearly"] = 10] = "Enterprise-Tiered_Yearly";
    PlanIds[PlanIds["Essentials_Yearly"] = 11] = "Essentials_Yearly";
    PlanIds[PlanIds["Essentials_Quarterly"] = 12] = "Essentials_Quarterly";
    PlanIds[PlanIds["Essentials_Monthly"] = 13] = "Essentials_Monthly";
    PlanIds[PlanIds["Essentials_Half-Yearly"] = 14] = "Essentials_Half-Yearly";
    PlanIds[PlanIds["Standard_Yearly"] = 15] = "Standard_Yearly";
    PlanIds[PlanIds["Standard_Quarterly"] = 16] = "Standard_Quarterly";
    PlanIds[PlanIds["Standard_Monthly"] = 17] = "Standard_Monthly";
    PlanIds[PlanIds["Standard_Half-Yearly"] = 18] = "Standard_Half-Yearly";
    PlanIds[PlanIds["Premium-V2_Yearly"] = 19] = "Premium-V2_Yearly";
    PlanIds[PlanIds["Premium-V2_Quarterly"] = 20] = "Premium-V2_Quarterly";
    PlanIds[PlanIds["Premium-V2_Monthly"] = 21] = "Premium-V2_Monthly";
    PlanIds[PlanIds["Premium-V2_Half-Yearly"] = 22] = "Premium-V2_Half-Yearly";
    PlanIds[PlanIds["Enterprise-V2_Yearly"] = 23] = "Enterprise-V2_Yearly";
    PlanIds[PlanIds["Enterprise-Tiered-V2_Yearly"] = 24] = "Enterprise-Tiered-V2_Yearly";
    PlanIds[PlanIds["Enterprise_Quarterly"] = 25] = "Enterprise_Quarterly";
    PlanIds[PlanIds["Enterprise-Tiered_Quarterly"] = 26] = "Enterprise-Tiered_Quarterly";
    PlanIds[PlanIds["Enterprise-V2_Quarterly"] = 27] = "Enterprise-V2_Quarterly";
    return PlanIds;
}({});
// String enums to get plan names.
export var PlanNames = /*#__PURE__*/ function(PlanNames) {
    PlanNames["Premium_Yearly"] = "Premium_Yearly";
    PlanNames["Premium_Quarterly"] = "Premium_Quarterly";
    PlanNames["Premium_Monthly"] = "Premium_Monthly";
    PlanNames["Professional_Yearly"] = "Professional_Yearly";
    PlanNames["Professional_Quarterly"] = "Professional_Quarterly";
    PlanNames["Professional_Monthly"] = "Professional_Monthly";
    PlanNames["Enterprise_Yearly"] = "Enterprise_Yearly";
    PlanNames["Premium_Half-Yearly"] = "Premium_Half-Yearly";
    PlanNames["Professional_Half-Yearly"] = "Professional_Half-Yearly";
    PlanNames["Enterprise-Tiered_Yearly"] = "Enterprise-Tiered_Yearly";
    PlanNames["Essentials_Yearly"] = "Essentials_Yearly";
    PlanNames["Essentials_Quarterly"] = "Essentials_Quarterly";
    PlanNames["Essentials_Monthly"] = "Essentials_Monthly";
    PlanNames["Essentials_Half-Yearly"] = "Essentials_Half-Yearly";
    PlanNames["Standard_Yearly"] = "Standard_Yearly";
    PlanNames["Standard_Quarterly"] = "Standard_Quarterly";
    PlanNames["Standard_Monthly"] = "Standard_Monthly";
    PlanNames["Standard_Half-Yearly"] = "Standard_Half-Yearly";
    PlanNames["Premium-V2_Yearly"] = "Premium-V2_Yearly";
    PlanNames["Premium-V2_Quarterly"] = "Premium-V2_Quarterly";
    PlanNames["Premium-V2_Monthly"] = "Premium-V2_Monthly";
    PlanNames["Premium-V2_Half-Yearly"] = "Premium-V2_Half-Yearly";
    PlanNames["Enterprise-V2_Yearly"] = "Enterprise-V2_Yearly";
    PlanNames["Enterprise-Tiered-V2_Yearly"] = "Enterprise-Tiered-V2_Yearly";
    PlanNames["Enterprise_Quarterly"] = "Enterprise_Quarterly";
    PlanNames["Enterprise-Tiered_Quarterly"] = "Enterprise-Tiered_Quarterly";
    PlanNames["Enterprise-V2_Quarterly"] = "Enterprise-V2_Quarterly";
    return PlanNames;
}({});
export var SubscriptionStatus = /*#__PURE__*/ function(SubscriptionStatus) {
    SubscriptionStatus["IN-TRIAL"] = "IN_TRIAL";
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    return SubscriptionStatus;
}({});
export var CurrencyCode = /*#__PURE__*/ function(CurrencyCode) {
    CurrencyCode[CurrencyCode["USD"] = 0] = "USD";
    return CurrencyCode;
}({});
export var PricingType = /*#__PURE__*/ function(PricingType) {
    PricingType["LICENSE-BASED"] = "LICENSE_BASED";
    PricingType["FIXED-PRICING"] = "FIXED_PRICING";
    return PricingType;
}({});
export var LicenseCapLimit = /*#__PURE__*/ function(LicenseCapLimit) {
    LicenseCapLimit[LicenseCapLimit["Professional"] = 10] = "Professional";
    LicenseCapLimit[LicenseCapLimit["Essentials"] = 10] = "Essentials";
    return LicenseCapLimit;
}({});
export var AddonsMapping = /*#__PURE__*/ function(AddonsMapping) {
    AddonsMapping["AiFills"] = "AI_FILLS";
    AddonsMapping["AiCredits"] = "AI_CREDITS";
    return AddonsMapping;
}({});
export var InvoiceStatus = /*#__PURE__*/ function(InvoiceStatus) {
    InvoiceStatus["PAID"] = "Paid";
    InvoiceStatus["NOT_PAID"] = "Not_Paid";
    InvoiceStatus["PAYMENT_DUE"] = "Payment_Due";
    InvoiceStatus["POSTED"] = "Posted";
    return InvoiceStatus;
}({});
